import { useFetchMilestoneIsssueViewQuery } from "../../../../slice/logdetailSlice";
import { useParams } from "react-router-dom";
import { CommonShowDocument } from "../../../common/AddDocumentComponent";

const MilestoneIssueDocument = ({ issue_id }) => {
  const { id } = useParams();
  const { refetch } = useFetchMilestoneIsssueViewQuery(id);
  // //console.log("show log hours id", id);

  return (
    <>
      <CommonShowDocument
        refetchList={refetch}
        showPath="milestones/issue/document"
        downloadPath="milestones/issue/document/download"
        deletePath="milestones/issue/document"
        type="milestones/issue"
      />
    </>
  );
};

export default MilestoneIssueDocument;
